import { lazy } from "react";

export const DynamicRequestPage = lazy(() => import("./dynamic-request"));
export {
  DYNAMIC_REQUEST_CREATE_PATH,
  DYNAMIC_REQUEST_EDIT_PATH,
} from "./dynamic-request-path";
